import React, {useState, useEffect} from 'react'
import VideoItem from '../Home/VideoItem'
import axios from 'axios'
import "./AllVideos.css"
import PremieredVideoItem from '../Home/PremieredVideoItem'
import { validateExpirationDate } from '../../utils/handlePremiereDates'

const AllVideos = ({user, setFile}) => {
    const [allVideos, setAllVideos] = useState([])
    const [count, setCount] =useState(1)
    const [limit, setLimit] = useState(0)
    const [loadingAllVideos, setLoadingAllVideos]=useState(true)
    const [results, setResults] = useState(10)
    useEffect(()=>{
      if(user&& loadingAllVideos && results){
        getAllVideos().then(res=>{
          let all=res.data.allFiles.map(file=>{ let video =file
            video.type="all"; return video});
            setLimit(res.data.record/Number(results))
          setAllVideos(all)
        setLoadingAllVideos(!loadingAllVideos)
        }).catch(err=>console.log(err))
      }
    },[user, loadingAllVideos, results])
    const getAllVideos = () => {
      return axios.post("https://tf4pr3wftk.execute-api.us-west-2.amazonaws.com/default/api/all", {_id:user, page:count, results:results})
    }
  return (
    <div>
    <p className="home-section-header">All Videos</p>
    <div className="row mb-3 border-bottom" style={{display:"flex", justifyContent:"center"}}>



      {!loadingAllVideos? allVideos.map((item)=>{
        if (validateExpirationDate(item?.premiereDate)) {
          return <PremieredVideoItem videoObj={item}/>
        } else{
          return <VideoItem
          key={item._id}
          item={item}
          color={
           "#2196F2"}
           onClick={() => {
             setFile(item, [], "vid");
           }}/>
        }
       
      }):
    <i class="fa-sharp fa-spin fa-solid fa-circle-notch"></i>}

      <div className="avResPerPage">
        <label>Results per page <select onChange={(e) =>{e.preventDefault(); setResults(e.target.value); setCount(1); setLoadingAllVideos(!loadingAllVideos)}}>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select></label>
      </div>
    </div>
    <div style={{display:"flex", justifyContent:"space-between"}}>
      {count>1?
     <button className='btn btn-outline-primary' style={{width:'25%'}}  onClick={(e)=>{e.preventDefault(); setCount(count-1); setLoadingAllVideos(!loadingAllVideos)}}> <svg style={{width:"15%"}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
    </svg></button>

      :<div style={{width:'25%'}}/>}
      <div className="avPageCount">
        {`Page ${count} of `}

        {limit>0?`${parseInt(limit)+1}`:<i class="fa-sharp fa-spin fa-solid fa-circle-notch"></i>}
      </div>

      {count<parseInt(limit)+1?
        <button className='btn btn-outline-primary' style={{width:'25%'}}  onClick={(e)=>{e.preventDefault(); setCount(count+1); setLoadingAllVideos(!loadingAllVideos)}}> <svg style={{width:"15%"}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
      </svg>
      </button>

         :""}
    </div>
  </div>
  )
}

export default AllVideos
